import { JSONSchemaType } from 'ajv'

export interface IConnectorPermissionFormData {
  conduccoConnectorId: string
  read: boolean
  write: boolean
  edit: boolean
  isInactive: boolean
}

const ConnectorPermissionSchema: JSONSchemaType<IConnectorPermissionFormData> = {
  type: 'object',
  properties: {
    conduccoConnectorId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    read: {
      type: 'boolean',
      default: false,
    },
    write: {
      type: 'boolean',
      default: false,
    },
    edit: {
      type: 'boolean',
      default: false,
    },
    isInactive: {
      type: 'boolean',
      default: false,
    },
  },
  required: ['conduccoConnectorId'],
  additionalProperties: false,
}

export default ConnectorPermissionSchema
